<div class="togg text-center" style="padding-top: 18px;" (click)="toggle.click()">
    <input type="checkbox" #toggle id="toggle" [checked]="status == 'active'" (change)="togglee()">
    <label class="toggle-button-switch ">
        <div class="shape rounded-circle bg-white h-100"></div>
    </label>
    <div class="toggle-button-text">
        <div class="toggle-button-text-on">ON</div>
        <div class="toggle-button-text-off">OFF</div>
    </div>
</div>